// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__44PhN","badges":"styles_badges__372G1"};